import React, { useState } from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Visibility as ShowIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { useListContext, useRedirect } from 'react-admin';
import EditLeadModal from './EditLeadModal.component';
import logger from '../../utils/logger';
const ActionsMenu = ({ record }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { refetch } = useListContext();
  const redirect = useRedirect();
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    logger.log('ActionsMenu: Opening edit modal for lead ID:', record.id);
    setIsEditModalOpen(true);
    handleClose();
  };

  const handleEditSuccess = () => {
    refetch();
  };

  const handleShowClick = () => {
    // Navigate to show page using React Admin redirect
    redirect(`/leads/${record.id}/show`);
    handleClose();
  };

  if (!record || !record.id) {
    return null;
  }

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            width: '20ch',
          },
        }}
      >
        <MenuItem onClick={handleShowClick}>
          <ListItemIcon>
            <ShowIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View Details</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleEditClick}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit Lead</ListItemText>
        </MenuItem>
      </Menu>

      <EditLeadModal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        onSuccess={handleEditSuccess}
        leadId={record.id}
      />
    </>
  );
};

export default ActionsMenu;
